import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Router } from 'react-router-dom';
import history from '../browserHistory';
import { Spinner } from 'reactstrap';
import style from './login-container.module.css';
const LoginLazy = lazy(() => import('../components/Login/login'));
const LoginOverdueLazy = lazy(() => import('../components/Login/Overdue'));
const LoginResetLazy = lazy(() => import('../components/Login/Reset'));
const LoginInActiveLazy = lazy(() => import('../components/Login/Inactive'));
const LoginResetSentLazy = lazy(() => import('../components/Login/Sent'));
const LoginResetExpiredLazy = lazy(() => import('../components/Login/Expired'));
const LoginChangeLazy = lazy(() => import('../components/Login/Change'));
const LoginChangeSuccessLazy = lazy(() =>
  import('../components/Login/Success'),
);

const LoginContainer = () => {
  return (
    <Router history={history}>
      <Suspense fallback={<Spinner className={style.spinner} type="grow" />}>
        <Switch>
          <Route exact path="/" component={LoginLazy} />
          <Route exact path="/login" component={LoginLazy} />
          <Route exact path="/login/overdue" component={LoginOverdueLazy} />
          <Route exact path="/login/inactive" component={LoginInActiveLazy} />
          <Route exact path="/login/reset" component={LoginResetLazy} />
          <Route
            exact
            path="/login/reset/sent"
            component={LoginResetSentLazy}
          />
          <Route
            exact
            path="/login/reset/expired"
            component={LoginResetExpiredLazy}
          />
          <Route exact path="/login/change" component={LoginChangeLazy} />
          <Route
            exact
            path="/login/change/success"
            component={LoginChangeSuccessLazy}
          />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default LoginContainer;
